import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'ttsTranslate'
})
export class TtsTranslatePipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(separator: string, ...translatrKeys: string[]): string {
    const translations = translatrKeys.map(key => key ? this.translate.instant(key): '');
    return translations.join(separator);
  }
}